// Mock data for D Soto Cleaning Landing Page

export const services = [
  {
    id: 1,
    title: "Interior Vacuuming",
    description: "Professional deep interior cleaning for fleet vehicles.",
    icon: "wind"
  },
  {
    id: 2,
    title: "Professional Auto Waxing",
    description: "Exterior shine and long-term paint protection.",
    icon: "sparkles"
  },
  {
    id: 3,
    title: "Full Exterior Body Wash",
    description: "Complete hand wash process for high-volume operations.",
    icon: "droplets"
  },
  {
    id: 4,
    title: "Interior Deodorizing",
    description: "Advanced odor neutralization treatment.",
    icon: "airVent"
  },
  {
    id: 5,
    title: "Seat Shampoo & Extraction",
    description: "Deep fabric cleaning and stain removal.",
    icon: "armchair"
  },
  {
    id: 6,
    title: "Steam Cleaning",
    description: "High-temperature sanitation process.",
    icon: "flame"
  },
  {
    id: 7,
    title: "Wheel & Rim Cleaning",
    description: "Detailed tire and brake dust removal.",
    icon: "circle"
  },
  {
    id: 8,
    title: "Odor, Smoke & Pet Hair Removal",
    description: "Complete interior recovery service.",
    icon: "shieldCheck"
  },
  {
    id: 9,
    title: "Baby Car Seat Cleaning",
    description: "Specialized cleaning and maintenance for baby car seats with heightened attention to hygiene, material care, and safety-focused handling.",
    icon: "baby"
  },
  {
    id: 10,
    title: "Quick Turnaround",
    description: "Fast, structured vehicle preparation process designed to support high-volume operations without compromising communication, consistency, or quality standards.",
    icon: "clock"
  }
];

export const contactFormSubmit = (formData) => {
  // Mock form submission - stores in localStorage for demo
  const submissions = JSON.parse(localStorage.getItem('contactSubmissions') || '[]');
  const newSubmission = {
    ...formData,
    id: Date.now(),
    timestamp: new Date().toISOString()
  };
  submissions.push(newSubmission);
  localStorage.setItem('contactSubmissions', JSON.stringify(submissions));
  
  return {
    success: true,
    message: "Thank you for your interest. We'll contact you within 24 hours.",
    data: newSubmission
  };
};
